import React from 'react';
import classNames from 'classnames';

type HrProps = {
  className?: string;
  borderColour?: string;
};

const Hr: React.FC<HrProps> = ({ className, borderColour = '#F5F5F5' }) => {
  return (
    <hr
      className={classNames(className, 'border-t-0 border-b my-6')}
      style={{ borderColor: borderColour }}
    />
  );
};

export default Hr;
